/* eslint-disable react-hooks/exhaustive-deps */
import IconView from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../app/slices/commonSlice";
import { fetchUsers, resetStateUsers } from "../../app/slices/usersSlice";
import { translateStatus } from "../../app/utils";
import TopLinks from "../../components/TopLinks/TopLinks";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import UserActionDialog from "./UserActionDialog";

const Users = () => {
  const {
    get: { list: listUsers, status: statusGet, error: errorGet },
    put: { data: dataPut, error: errorPut, status: statusPut },
  } = useSelector(({ users }) => users);

  const [data, setData] = useState([]);
  const topLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "Users",
      isCurrent: false,
    },
  ];

  const columns = [
    {
      name: "REQUEST_ID",
      label: "Request ID",
      options: {
        visible: false,
      },
    },
    {
      name: "FULL_NAME",
      label: "Full Name",
    },
    {
      name: "EMAIL",
      label: "Email",
    },
    {
      name: "PHONE_NUMBER",
      label: "Phone",
    },
    {
      name: "CATEGORY",
      label: "Category",
    },
    {
      name: "INCORPORATION_NUMBER",
      label: "Incorporation Number",
    },
    {
      name: "STATUSDISPLAY",
      label: "Status",
    },
  ];

  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  const dispatch = useDispatch();

  //* use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateUsers());
    };
  }, []);

  useEffect(() => {
    if (listUsers?.length) {
      let remapped = [];
      listUsers.forEach((user) =>
        remapped.push({
          ...user,
          STATUSDISPLAY: translateStatus(user.STATUS),
        })
      );

      setData(remapped);
    }
  }, [listUsers]);

  useEffect(() => {
    if (errorPut) {
      dispatch(
        showSnackbar({
          open: true,
          message: errorPut?.message || "An error occurred",
          type: "error",
        })
      );
    }
  }, [errorPut]);

  //* methods
  const loadResources = () => {
    dispatch(resetStateUsers());
    dispatch(fetchUsers());
  };

  //* builders
  return (
    <>
      <TopLinks links={topLinks} />

      <Button
        size="small"
        id="btn-submit"
        margin="dense"
        color="primary"
        variant="contained"
        onClick={() => {
          setOpen(true);
        }}
      >
        Register User
      </Button>

      {statusGet === "loading" && (
        <LoadingContainer
          hasBackground={true}
          message="Loading users"
          id="loading-container-users"
        />
      )}

      {errorGet !== null && statusGet !== "loading" && (
        <ErrorContainer
          id="error-container-users"
          hasBackground={true}
          message={errorGet?.message || "An error occurred"}
          onReload={() => {
            loadResources();
          }}
        />
      )}

      {statusGet === "idle" && listUsers?.length <= 0 && errorGet === null && (
        <EmptyDataContainer
          message="No users found"
          hasBackground={true}
          id="empty-data-users"
        />
      )}

      {listUsers?.length > 0 && errorGet === null && statusGet === "idle" && (
        <AppDataTable
          id="user-list"
          action={[
            {
              action: "View Details",
              onClick: (item) => {
                setDialogData(item);
                setOpen(true);
              },
            },
          ]}
          actionIcon={<IconView />}
          columns={columns}
          data={data}
          emptyMessage="Nothing found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="System Users"
        />
      )}

      {open && (
        <UserActionDialog
          open={open}
          handleClose={(res) => {
            setOpen(false);
            setDialogData(null);
            if (res) {
              loadResources();
            }
          }}
          data={dialogData}
        />
      )}
    </>
  );
};

export default Users;
